// Cómo elige una cuenta de la línea lo que mide (`BusinessUnitCampaignsConfiguration._selection_method`).
//
// Viven en su propio módulo, sin React, para que los helpers puros (`line_wizard/campaignsPreview.js`,
// `elements/uncoveredSpend.js`) no tengan que importar el componente de la edición clásica, que a su vez
// usa esos helpers: con el import cruzado, el módulo que se evaluaba segundo veía las constantes en
// `undefined`. `AccountCampaignsConfiguration` las reexporta, así que los imports de siempre siguen andando.
export const METHOD_INCLUDE_ALL_CAMPAIGNS = "INCLUDE_ALL_CAMPAIGNS";
export const METHOD_SELECT_CAMPAIGNS_FROM_LIST = "SELECT_CAMPAIGNS_FROM_LIST";
export const METHOD_INCLUDE_CAMPAIGN_ON_CONDITION = "INCLUDE_CAMPAIGN_ON_CONDITION";
export const METHOD_SELECT_ADGROUPS_FROM_LIST = "SELECT_ADGROUPS_FROM_LIST";
export const METHOD_INCLUDE_ADGROUP_ON_CONDITION = "INCLUDE_ADGROUP_ON_CONDITION";
